<template>
  <div id="page-forms">
    <v-container fluid>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex lg4 sm4>
            <p>
              <v-icon>schedule</v-icon>&nbsp;&nbsp; Is this event affect Prod.Scheduling
            </p>
            <v-radio-group v-model="form.login">
              <v-radio label="Yes" value="yes-1"></v-radio>
              <v-radio label="No" value="No-1"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex lg8 sm8>
            <p>
              <v-icon>track_changes</v-icon> &nbsp;&nbsp;Which area is affected?
            </p>
            <v-checkbox label="Block Location for specific type of Prod.Order" v-model="checkedNames"></v-checkbox>
            <v-checkbox label="Block the Location with no Production" v-model="checkedNames"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
export default {
  components: {
    VWidget
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    saveCard: true,
    valid: true,
    form: {
      holidayName: '',
      fulfilmentstatusId: ''
    }
  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    submit () {
      this.$validator.validateAll();
    },
    clear () {
      this.form = {};
      this.$validator.reset();
    }
  }
};
</script>






// WEBPACK FOOTER //
// src/pages/calendar/PPProductionSchedule.vue